import { api } from './base';

import { MutationArg, Pageable } from 'v2/types';
import { CheaterModel, CheatersFilter } from 'v2/types/CheaterModel';
import { FingerprintFilter, FingerprintModel } from 'v2/types/FingerprintModel';
import { SWRKeyPaginationWithExtra, SWRKeyValue } from 'v2/types/swr';
import { UserFilter, UserModel } from 'v2/types/UserModel';
import { normalizeSearch, shitFilterMapper } from 'v2/utils';

export const userService = {
  getUser([_key, userId]: SWRKeyValue): Promise<UserModel> {
    return api.get(`v1/admin/user/${userId}`).json();
  },

  searchUsers([_key, searchValue]: SWRKeyValue): Promise<Pageable<UserModel>> {
    return api.get('v1/admin/user/search', { searchParams: { searchValue, isStrictSearch: false } }).json();
  },

  getUsers([_key, page, limit, filter]: SWRKeyPaginationWithExtra<UserFilter>): Promise<Pageable<UserModel>> {
    const { geo, ...textFilter } = filter;
    return api
      .get('v1/admin/user', {
        searchParams: normalizeSearch({ page, limit, filter: shitFilterMapper(textFilter), ...(geo ? { geo } : {}) }),
      })
      .json();
  },

  updateUser([_key, userId]: SWRKeyValue, { arg }: MutationArg<Partial<UserModel>>): Promise<UserModel> {
    return api.put(`v1/admin/user/${userId}`, { json: arg }).json();
  },

  deleteUser([_key, userId]: SWRKeyValue): Promise<UserModel> {
    return api.delete(`v1/admin/user/${userId}`).json();
  },

  getCheaters([_key, page, limit, filter]: SWRKeyPaginationWithExtra<CheatersFilter>): Promise<Pageable<CheaterModel>> {
    return api
      .get('v1/admin/cheater', {
        searchParams: { page, limit, filter: JSON.stringify(filter), sortFields: JSON.stringify({ date: 'asc' }) },
      })
      .json();
  },

  getSuspiciousFingerprints([_key, page, limit, filter]: SWRKeyPaginationWithExtra<FingerprintFilter>): Promise<
    Pageable<FingerprintModel>
  > {
    return api
      .get('v1/admin/user-metrics/suspicious', {
        searchParams: {
          page,
          limit,
          sortFields: JSON.stringify({ _id: 'asc' }),
          ...(filter.userNicknames && { filter: JSON.stringify(filter) }),
        },
      })
      .json();
  },

  checkFingerprint([_key, fingerprintId]: SWRKeyValue): Promise<FingerprintModel> {
    return api.put(`v1/admin/user-metrics/check/${fingerprintId}`).json();
  },

  payOutDiamondsForAll(_key: string, { arg }: MutationArg<number>): Promise<void> {
    return api.patch('v1/admin/user/diamonds/all', { json: { amount: arg } }).json();
  },

  getTemporalId(
    [_key, userId]: SWRKeyValue,
    { arg: tournamentId }: MutationArg<string>
  ): Promise<{ balanceId: string }> {
    return api.get(`admin/balance/${userId}/tournament/${tournamentId}/balance-id`).json();
  },
};
